import { Action } from "redux";
import { LoadStatus, ThunkAction } from "../types/index.js";
import { insertScriptIntoHead } from "../utils/utils.js";
import { isActionType } from "./utils.js";

const ActionTypeKeys = ["LOAD_SCRIPT"] as const;

type ActionType = (typeof ActionTypeKeys)[number];
type ActionBase<T extends ActionType> = Action<T>;

type LoadScript = ActionBase<"LOAD_SCRIPT"> & {
  url: string;
  status: LoadStatus;
};

export type LoadStateAction = LoadScript;

export const isLoadStateAction = (action: Action): action is LoadStateAction =>
  isActionType(action, ActionTypeKeys);

export const injectScript =
  (url: string): ThunkAction<Promise<void>> =>
  async (dispatch, getState) => {
    const loadState = getState().loadStates.scripts[url];
    if (loadState === "loaded" || loadState === "loading") {
      return;
    }
    dispatch(loadScript(url, "loading"));
    try {
      await insertScriptIntoHead(url, document);
      dispatch(loadScript(url, "loaded"));
    } catch (error) {
      dispatch(loadScript(url, "unloaded"));
    }
  };

export const loadScript = (url: string, status: LoadStatus): LoadScript => ({
  type: "LOAD_SCRIPT",
  url,
  status,
});
